import React from 'react';
import {Dialog} from "primereact/dialog";
import {InputSwitch} from "primereact/inputswitch";
import md5 from "md5";
import InnerLoading from "../Viabilidade/InnerLoading";
import ResultCard from "./ResultCard";

class ModalColetas extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showIgnored: false, ignorados: [],
        }
    }

    frequencyLabels = {
        "MONTHLY": "Mensal",
        "WEEKLY": "Semanal",
        "DAILY": "Diário",
        "ONLY_ONCE": "Único",
    }

    calcHash = (coleta) => {
        return md5(this.props.site?.link + '-' + coleta.title);
    }

    handleShowIgnored = () => {
        this.setState({showIgnored: !this.state.showIgnored});
    }

    //certifica-se de que as propriedades são atualizadas
    static getDerivedStateFromProps(props, state) {
        return {
            ignorados: props.ignorados
        }
    }

    render() {
        return (<>
            <Dialog
                header="Coletas"
                visible={this.props.show}
                style={{width: '70vw', marginTop: '30px'}}
                onHide={this.props.handleClose}
                blockScroll={true}
            >

                <div className="container-fluid">
                    {this.props.loading && <InnerLoading/>}

                    <div className="card-body" style={{paddingLeft: '0px'}}>
                        <div className="d-flex align-items-center" style={{height: '50px', paddingLeft: '0px'}}>
                            <label htmlFor="" className="d-flex align-items-center gap-2">
                                {this.props.ignorados.length > 0 && (<>
                                    Mostrar Ignorados &nbsp;
                                    <span className="font-weight-bold">{this.props.ignorados.length}</span> &nbsp;
                                    <InputSwitch
                                        checked={this.state.showIgnored}
                                        onChange={this.handleShowIgnored}
                                    />
                                </>)}
                            </label>
                        </div>
                    </div>

                    <div className="card-body" style={{border: '1px solid #ccc', marginBottom: '10px', backgroundColor: '#D3D3D3'}}>

                        <h5 className="card-title text-uppercase" style={{marginBottom: '15px'}}>{this.props.site?.portal} - {this.props.site?.link}</h5>
                        <hr />
                        <p>
                            <strong>Data Criação do Workflow:</strong> {this.props.site?.workflow_created_at_formatted}
                        </p>

                        <p>
                            <strong>Última Execução:</strong> {this.props.site?.ultima_execucao_workflow_formatted}
                        </p>
                        <p>
                            <strong>Frequência:</strong> {this.frequencyLabels[this.props.site?.workflow_frequency]}
                        </p>

                        <p>
                            <strong>Número de Execuções:</strong> {this.props.site?.runs_count}
                        </p>

                        <p>
                            <strong>Resultados da Última Coleta: </strong> {this.props.coletas.length}
                        </p>

                        <p>
                            <strong>Resultados Ignorados: </strong> {this.props.ignorados.length}
                        </p>
                    </div>


                    {this.props.coletas.map((coleta, index) => {

                        const hash = this.calcHash(coleta);

                        if (this.state.ignorados.includes(hash) && !this.state.showIgnored) {
                            return null;
                        }

                        return (
                            <ResultCard key={index} coleta={coleta} />
                        );
                    })}
                </div>
            </Dialog>
        </>);
    }
}

export default ModalColetas;
